// 메일 템플릿 조건값 토큰 헬퍼 — 저장 문자열('568', 'a|b', '[1-5]')을 원문 그대로 쪼개고 합친다.
// node:test + webpack 양쪽 사용을 위해 CommonJS 로 작성.

// mail template contexts 값 컬럼이 String(512).
const MAX_CONDITION_LENGTH = 512

// '|' 로만 나눈다. trim/숫자 변환을 하지 않아야 불러온 값을 그대로 다시 저장할 수 있다.
function splitTokens(value) {
    if (value == null) return []
    return String(value).split('|').filter((token) => token !== '')
}

// 중복은 첫 등장만 남긴다.
function joinTokens(tokens) {
    return [...new Set(tokens || [])].join('|')
}

function isRangeToken(token) {
    return /^\[\d+-\d+\]$/.test(token)
}

module.exports = {
    MAX_CONDITION_LENGTH,
    splitTokens,
    joinTokens,
    isRangeToken,
}
